import sdl from '@jds/react-generated-sdl/JDSBadgeV2Brand';
import type { JDSBadgeV2BrandProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSBadgeV2BrandProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'circle-label',
    size = 'xtra-xtra-xtra-large',
    emphasis = 'light',
    ariaLabel = props.label?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { kind, size, emphasis, ariaLabel, ...rest },
    'JDSBadgeV2Brand',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const BadgeV2Brand = withLogic(Component) as React.FC<JDSBadgeV2BrandProps> & {
  slotName?: string;
};

BadgeV2Brand.displayName = 'BadgeV2Brand';
BadgeV2Brand.slotName = 'jds_badge_v_2_brand';

export { BadgeV2Brand, type JDSBadgeV2BrandProps };
